import {View, Sync} from 'MWC';
import tpl from '../templates/interactive.jsx';
import {apiback} from 'config';
import {utmMarks} from '../../../utmMarks.js';
import {canUseDOM} from '../../../helpers/canUseDOM.js';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            activeScreen: 'form',
            withUtmMarks: false,
            productName: props.product,
            ageConfirm: false,
            isLoading: false,
            isMobile: canUseDOM ? window.innerWidth <= 640 : false,
            contactPhoneNumber: {
                value: '',
                firstInput: true,
                isValid: false,
                isTouched: false
            }
        };

        this._initMethods();
    }

    updateWidth = () => {
        this.setState({isMobile: window.innerWidth <= 640});
    };

    validatePhone(value) {
        const digits = value.replace(/\D/g, '');
        if (!value || value.trim() === '' || digits.length < 12) {
            return false;
        }
        return true;
    }

    handleChange(value) {
        const isPhoneValid = this.validatePhone(value);

        this.setState(prev => ({
            ...prev,
            contactPhoneNumber: {
                ...prev.contactPhoneNumber,
                value,
                isValid: isPhoneValid
            }
        }));
    }

    handleSetIsTouched() {
        this.setState(prev => ({
            ...prev,
            contactPhoneNumber: {
                ...prev.contactPhoneNumber,
                isTouched: true
            }
        }));
    }

    onBlurHandle() {
        const isPhoneValid = this.validatePhone(this.state.contactPhoneNumber.value);

        this.setState(prev => ({
            ...prev,
            contactPhoneNumber: {
                ...prev.contactPhoneNumber,
                firstInput: false,
                isValid: isPhoneValid
            }
        }));
    }

    handleCheckbox() {
        this.setState(prev => ({ageConfirm: !prev.ageConfirm}));
    }

    handleEscape(event) {
        if (event.keyCode === 27) {
            this.closeModal();
        }
    }

    closeModal = () => {
        this.props.closeModal && this.props.closeModal();
    };

    async sendForm() {
        this.setState({isLoading: true});
        const {contactPhoneNumber, productName, ageConfirm} = this.state;
        const Engine = Sync.getEngine('xhr');
        const url = apiback('API_COREZOID');

        const normalizedPhone = contactPhoneNumber.value.replace(/[^\d+]/g, '');

        const data = {
            conv_data: {
                phone: normalizedPhone,
                link: window.location.href,
                product: this.props.downloadAppBottom
                    ? window.location.pathname.replace(/^\/|\/$/g, '').split('?')[0]
                    : productName
            },
            hash: productName === 'kid' ? 'D6F08E241D9F6EFC' : 'HG1P6DSQOLS1O2CD'
        };

        if (productName === 'kid') {
            data.conv_data.age = ageConfirm ? 'child' : 'per';
        }

        const xhr = new Engine({
            url: `${url}`,
            dataType: 'json',
            type: 'POST',
            contentType: 'application/json',
            data,
            cache: false
        });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                if (window.location.pathname.includes('/cards')) {
                    window.dataLayer.push({
                        event: 'form_submit_card',
                        form_name: 'callback_request'
                    });
                }
                if (window.location.pathname.includes('/credit')) {
                    window.dataLayer.push({
                        event: 'form_submit_consult',
                        form_name: 'callback_request'
                    });
                }
                window.dataLayer.push({event: 'sendgreenform'});
                this.setState({activeScreen: 'success'});
            }
        } catch (error) {
            this.setState({activeScreen: 'error'});
            return error;
        } finally {
            this.setState({isLoading: false});
        }
    }

    _initMethods() {
        this.handleSetIsTouched = this.handleSetIsTouched.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onBlurHandle = this.onBlurHandle.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.sendForm = this.sendForm.bind(this);
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const hasUtm = utmMarks.some(mark => urlParams.has(mark));

        if (hasUtm) {
            this.setState({withUtmMarks: true});
        }

        document.body.classList.add('disable-scroll');
        window.addEventListener('keydown', this.handleEscape);
        window.addEventListener('resize', this.updateWidth);
    }

    componentWillUnmount() {
        document.body.classList.remove('disable-scroll');
        window.removeEventListener('keydown', this.handleEscape);
        window.removeEventListener('resize', this.updateWidth);
    }

    static displayName = 'Card.Order';
}
